import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "../ui/accordion";

const ITEMS = [
    {
        q: "Quanto tempo dura uma sessão?",
        a: "Cada sessão tem duração de 50 minutos, com hora marcada e ambiente cuidadosamente preparado para que você possa se concentrar inteiramente no processo.",
    },
    {
        q: "Com que frequência acontecem as sessões?",
        a: "A maioria dos atendimentos é semanal — essa frequência sustenta o processo terapêutico. Em alguns momentos, conversamos sobre ajustes (quinzenal, por exemplo), sempre conforme a sua necessidade clínica.",
    },
    {
        q: "Como funciona o atendimento online?",
        a: "As sessões online acontecem por videochamada em plataforma segura. A qualidade da escuta e do vínculo é a mesma do presencial — com a vantagem da continuidade do cuidado de onde você estiver.",
    },
    {
        q: "Quais são os valores e formas de pagamento?",
        a: "Os valores são apresentados no primeiro contato pelo WhatsApp, de forma transparente. Trabalho com pagamento por sessão (Pix, cartão e transferência) e emito recibo para reembolso quando aplicável.",
    },
    {
        q: "Como sei se a terapia de casal é para nós?",
        a: "Não é preciso esperar uma crise extrema. A terapia de casal acolhe desde dificuldades pontuais de comunicação até a vontade de cuidar preventivamente do vínculo. No primeiro contato avaliamos juntos se faz sentido.",
    },
    {
        q: "Quanto tempo costuma durar o processo terapêutico?",
        a: "Não existe um tempo único. Algumas questões pedem alguns meses; outras pedem um percurso mais longo. O ritmo é construído com você, com pausas e avaliações sempre que necessário.",
    },
    {
        q: "Tudo o que eu disser fica em sigilo?",
        a: "Sim. O sigilo é garantido pelo Código de Ética da Psicologia (CFP) e é uma das bases mais importantes do nosso trabalho. Esse é um espaço seu — protegido e respeitoso.",
    },
];

export const FAQ = () => {
    return (
        <section id="faq" data-testid="faq-section" className="py-24 lg:py-32 bg-[#F5F4F2]">
            <div className="max-w-5xl mx-auto px-6 lg:px-10">
                <div className="max-w-2xl mb-14 reveal">
                    <p className="overline mb-5">Perguntas frequentes</p>
                    <h2 className="font-display text-4xl sm:text-5xl lg:text-[3.4rem] leading-[1.08] text-[#2F2F2F]">
                        Antes do primeiro passo,
                        <span className="italic text-[#9f1e1e]"> respostas honestas.</span>
                    </h2>
                </div>

                <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
                    {ITEMS.map((item, i) => (
                        <AccordionItem
                            key={i}
                            value={`item-${i}`}
                            className="border-b border-[#B7A6B0]/50"
                            data-testid={`faq-item-${i}`}
                        >
                            <AccordionTrigger
                                className="faq-trigger py-6 text-left font-display text-xl lg:text-2xl text-[#2F2F2F] hover:no-underline"
                            >
                                {item.q}
                            </AccordionTrigger>
                            <AccordionContent className="pb-7 text-[15px] leading-relaxed text-[#2F2F2F]/80 max-w-3xl">
                                {item.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </div>
        </section>
    );
};
